import { AdLoader } from './ad-loader';
import yall from 'yall-js';
import boot from './map.js';
import textBalancer from 'text-balancer';

// Kickstart the ads
const adLoader = new AdLoader();
adLoader.init();

// Lazy load the photos
document.addEventListener('DOMContentLoaded', yall);

// Boot the map
boot();

textBalancer.balanceText();

// Swap videos based on screen size
var videos = ['LEAD', 'WELL', 'ELKHILLS'];

function videoSwap() {
  var windowSize = window.innerWidth;
  videos.forEach(function(x) {
    var videoElement = document.getElementById(x);
    const desktopName = x + '_DESKTOP';
    const mobileName = x + '_MOBILE';
    const desktopPoster = x.toLowerCase() + '_desktop';
    const mobilePoster = x.toLowerCase() + '_mobile';
    var videoNameAttr = videoElement.getAttribute('data-videoname');
    if (windowSize < 600 && videoNameAttr == 'desktopversion') {
      videoElement.setAttribute('src', window.VIDEOS[mobileName]);
      videoElement.setAttribute('poster', window.POSTERS[mobilePoster]);
      videoElement.setAttribute('data-videoname', 'mobileversion');
    } else if (windowSize > 600 && videoNameAttr == 'mobileversion') {
      console.log('Mobile');
      videoElement.setAttribute('src', window.VIDEOS[desktopName]);
      videoElement.setAttribute('poster', window.POSTERS[desktopPoster]);
      videoElement.setAttribute('data-videoname', 'desktopversion');
    }
  });
}

videoSwap(videos);
window.onresize = videoSwap;
